import React from "react";
import { ShieldCheck, FlaskConical, Gem, PackageCheck } from "lucide-react";
import { StaggerGroup, StaggerItem } from "@/components/motion/Reveal";

const ITEMS = [
  { icon: ShieldCheck, title: "Trusted Quality", desc: "Careful handling and organized product information." },
  { icon: FlaskConical, title: "Research Focused", desc: "Presented strictly for laboratory and analytical use." },
  { icon: Gem, title: "Premium Presentation", desc: "Clear, professional and consistent throughout." },
  { icon: PackageCheck, title: "Discreet Shipping", desc: "Protective, discreet packaging on every order." },
];

export default function TrustStrip() {
  return (
    <section className="bg-white border-y border-[#1E2A44]/8" aria-label="Why Renova">
      <div className="container-rnv py-12 md:py-16">
        <StaggerGroup className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {ITEMS.map(({ icon: Icon, title, desc }) => (
            <StaggerItem key={title} className="flex items-start gap-4">
              <span className="shrink-0 w-11 h-11 rounded-sm border border-[#C8A96A]/60 flex items-center justify-center text-[#C8A96A]">
                <Icon size={20} strokeWidth={1.5} />
              </span>
              <div>
                <h3 className="font-serif text-xl text-[#1E2A44]">{title}</h3>
                <p className="mt-1 text-sm text-[#85827D] leading-relaxed">{desc}</p>
              </div>
            </StaggerItem>
          ))}
        </StaggerGroup>
      </div>
    </section>
  );
}
